module.exports = __webpack_public_path__ + "etcnstatic/img/logowall.9fe6379.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logowall.png
// module id = ACuL
// module chunks = 1